import React from "react"
import { isNil } from "lodash"
import moment from "moment"
import Formatters from '../../../shared/utils/Formatters';

export default function Full({
  creditLimit,
  redirectTo,
  url,
}) {

  const { expected_unlock_date } = creditLimit;

  function onClick() {
    redirectTo(url);
  }

  function expectedUnlockDate() {
    if (isNil(expected_unlock_date)) { return '' }
    let date = moment(expected_unlock_date)
    return date.isValid() ? Formatters.date(date) : ''
  }

  return(
   <div className="ds-card" data-testid="full-util-card">
    <section className="cardSection _textAlign_center -warning">
      <h2 className="subhead -darkBlue" data-testid='100-percent-utilization-title'>You've used up your credit limit</h2>
      <p className="byline -secondary --small">You'll be able to apply for a loan again on <strong data-testid='expected-unlock-date'>{expectedUnlockDate()}</strong>, if you make sure to pay on time.</p>
      <button className="ds-btn --micro -warning _displayBlock _margin--auto" 
        data-testid='understand-your-limits-button' data-path={url} onClick={onClick}>
        Understand your limits
      </button>
    </section>
   </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/CreditLimit/components/utilization/Full.js